export default __webpack_public_path__ + "static/media/arrowL.58979e20.png";